function Ht(e) {
  return Object.keys(e).reduce((n, r) => {
    const i = e[r];
    return n[r] = Object.assign({}, i), mt(i.value) && !Gt(i.value) && !Array.isArray(i.value) && (n[r].value = Object.assign({}, i.value)), Array.isArray(i.value) && (n[r].value = i.value.slice(0)), n;
  }, {});
}
function Ut(e) {
  return e ? Object.keys(e).reduce((n, r) => {
    const i = e[r];
    return n[r] = mt(i) && "value" in i ? i : {
      value: i
    }, n[r].attribute || (n[r].attribute = Zt(r)), n[r].parse = "parse" in n[r] ? n[r].parse : typeof n[r].value != "string", n;
  }, {}) : {};
}
function qt(e) {
  return Object.keys(e).reduce((n, r) => (n[r] = e[r].value, n), {});
}
function Wt(e, t) {
  const n = Ht(t);
  return Object.keys(t).forEach((i) => {
    const l = n[i], o = e.getAttribute(l.attribute), s = e[i];
    o && (l.value = l.parse ? vt(o) : o), s != null && (l.value = Array.isArray(s) ? s.slice(0) : s), l.reflect && st(e, l.attribute, l.value), Object.defineProperty(e, i, {
      get() {
        return l.value;
      },
      set(c) {
        const u = l.value;
        l.value = c, l.reflect && st(this, l.attribute, l.value);
        for (let a = 0, f = this.__propertyChangedCallbacks.length; a < f; a++)
          this.__propertyChangedCallbacks[a](i, c, u);
      },
      enumerable: !0,
      configurable: !0
    });
  }), n;
}
function vt(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function st(e, t, n) {
  if (n == null || n === !1)
    return e.removeAttribute(t);
  let r = JSON.stringify(n);
  e.__updating[t] = !0, r === "true" && (r = ""), e.setAttribute(t, r), Promise.resolve().then(() => delete e.__updating[t]);
}
function Zt(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, n) => "-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function mt(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function Gt(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function Xt(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let xe;
function we() {
  Object.defineProperty(xe, "renderRoot", {
    value: xe
  });
}
function Yt(e, t) {
  const n = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return n.map((i) => t[i].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized)
        return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = Wt(this, t);
      const i = qt(this.props), l = this.Component, o = xe;
      try {
        xe = this, this.__initialized = !0, Xt(l) ? new l(i, {
          element: this
        }) : l(i, {
          element: this
        });
      } finally {
        xe = o;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected)
        return;
      this.__propertyChangedCallbacks.length = 0;
      let i = null;
      for (; i = this.__releaseCallbacks.pop(); )
        i(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(i, l, o) {
      if (this.__initialized && !this.__updating[i] && (i = this.lookupProp(i), i in t)) {
        if (o == null && !this[i])
          return;
        this[i] = t[i].parse ? vt(o) : o;
      }
    }
    lookupProp(i) {
      if (t)
        return n.find((l) => i === l || i === t[l].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(i) {
      this.__releaseCallbacks.push(i);
    }
    addPropertyChangedCallback(i) {
      this.__propertyChangedCallbacks.push(i);
    }
  };
}
function Jt(e, t = {}, n = {}) {
  const {
    BaseElement: r = HTMLElement,
    extension: i
  } = n;
  return (l) => {
    if (!e)
      throw new Error("tag is required to register a Component");
    let o = customElements.get(e);
    return o ? (o.prototype.Component = l, o) : (o = Yt(r, Ut(t)), o.prototype.Component = l, o.prototype.registeredTag = e, customElements.define(e, o, i), o);
  };
}
const _t = (e, t) => e === t, Ve = Symbol("solid-proxy"), $t = Symbol("solid-track"), Le = {
  equals: _t
};
let bt = xt;
const se = 1, Be = 2, pt = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
};
var U = null;
let De = null, Qt = null, H = null, X = null, ce = null, je = 0;
function Pe(e, t) {
  const n = H, r = U, i = e.length === 0, l = t === void 0 ? r : t, o = i ? pt : {
    owned: null,
    cleanups: null,
    context: l ? l.context : null,
    owner: l
  }, s = i ? e : () => e(() => Q(() => ze(o)));
  U = o, H = null;
  try {
    return $e(s, !0);
  } finally {
    H = n, U = r;
  }
}
function M(e, t) {
  t = t ? Object.assign({}, Le, t) : Le;
  const n = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, r = (i) => (typeof i == "function" && (i = i(n.value)), Ct(n, i));
  return [yt.bind(n), r];
}
function en(e, t, n) {
  const r = Ee(e, t, !0, se);
  _e(r);
}
function R(e, t, n) {
  const r = Ee(e, t, !1, se);
  _e(r);
}
function pe(e, t, n) {
  bt = an;
  const r = Ee(e, t, !1, se);
  (!n || !n.render) && (r.user = !0), ce ? ce.push(r) : _e(r);
}
function L(e, t, n) {
  n = n ? Object.assign({}, Le, n) : Le;
  const r = Ee(e, t, !0, 0);
  return r.observers = null, r.observerSlots = null, r.comparator = n.equals || void 0, _e(r), yt.bind(r);
}
function tn(e, t = _t, n) {
  const r = /* @__PURE__ */ new Map(), i = Ee((l) => {
    const o = e();
    for (const [s, c] of r.entries())
      if (t(s, o) !== t(s, l))
        for (const u of c.values())
          u.state = se, u.pure ? X.push(u) : ce.push(u);
    return o;
  }, void 0, !0, se);
  return _e(i), (l) => {
    const o = H;
    if (o) {
      let s;
      (s = r.get(l)) ? s.add(o) : r.set(l, s = /* @__PURE__ */ new Set([o])), Ge(() => {
        s.delete(o), !s.size && r.delete(l);
      });
    }
    return t(l, i.value);
  };
}
function lt(e) {
  return $e(e, !1);
}
function Q(e) {
  if (H === null)
    return e();
  const t = H;
  H = null;
  try {
    return e();
  } finally {
    H = t;
  }
}
function he(e) {
  pe(() => Q(e));
}
function Ge(e) {
  return U === null || (U.cleanups === null ? U.cleanups = [e] : U.cleanups.push(e)), e;
}
function nn() {
  return U;
}
function rn(e) {
  const t = H, n = U;
  return Promise.resolve().then(() => {
    H = t, U = n;
    let r;
    return $e(e, !1), H = U = null, r ? r.done : void 0;
  });
}
const [sn, Ir] = /* @__PURE__ */ M(!1);
function wt() {
  return [sn, rn];
}
function yt() {
  if (this.sources && this.state)
    if (this.state === se)
      _e(this);
    else {
      const e = X;
      X = null, $e(() => Oe(this), !1), X = e;
    }
  if (H) {
    const e = this.observers ? this.observers.length : 0;
    H.sources ? (H.sources.push(this), H.sourceSlots.push(e)) : (H.sources = [this], H.sourceSlots = [e]), this.observers ? (this.observers.push(H), this.observerSlots.push(H.sources.length - 1)) : (this.observers = [H], this.observerSlots = [H.sources.length - 1]);
  }
  return this.value;
}
function Ct(e, t, n) {
  let r = e.value;
  return (!e.comparator || !e.comparator(r, t)) && (e.value = t, e.observers && e.observers.length && $e(() => {
    for (let i = 0; i < e.observers.length; i += 1) {
      const l = e.observers[i], o = De && De.running;
      o && De.disposed.has(l), (o ? !l.tState : !l.state) && (l.pure ? X.push(l) : ce.push(l), l.observers && St(l)), o || (l.state = se);
    }
    if (X.length > 1e6)
      throw X = [], new Error();
  }, !1)), t;
}
function _e(e) {
  if (!e.fn)
    return;
  ze(e);
  const t = je;
  ln(e, e.value, t);
}
function ln(e, t, n) {
  let r;
  const i = U, l = H;
  H = U = e;
  try {
    r = e.fn(t);
  } catch (o) {
    return e.pure && (e.state = se, e.owned && e.owned.forEach(ze), e.owned = null), e.updatedAt = n + 1, Et(o);
  } finally {
    H = l, U = i;
  }
  (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? Ct(e, r) : e.value = r, e.updatedAt = n);
}
function Ee(e, t, n, r = se, i) {
  const l = {
    fn: e,
    state: r,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: U,
    context: U ? U.context : null,
    pure: n
  };
  return U === null || U !== pt && (U.owned ? U.owned.push(l) : U.owned = [l]), l;
}
function Re(e) {
  if (e.state === 0)
    return;
  if (e.state === Be)
    return Oe(e);
  if (e.suspense && Q(e.suspense.inFallback))
    return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < je); )
    e.state && t.push(e);
  for (let n = t.length - 1; n >= 0; n--)
    if (e = t[n], e.state === se)
      _e(e);
    else if (e.state === Be) {
      const r = X;
      X = null, $e(() => Oe(e, t[0]), !1), X = r;
    }
}
function $e(e, t) {
  if (X)
    return e();
  let n = !1;
  t || (X = []), ce ? n = !0 : ce = [], je++;
  try {
    const r = e();
    return on(n), r;
  } catch (r) {
    n || (ce = null), X = null, Et(r);
  }
}
function on(e) {
  if (X && (xt(X), X = null), e)
    return;
  const t = ce;
  ce = null, t.length && $e(() => bt(t), !1);
}
function xt(e) {
  for (let t = 0; t < e.length; t++)
    Re(e[t]);
}
function an(e) {
  let t, n = 0;
  for (t = 0; t < e.length; t++) {
    const r = e[t];
    r.user ? e[n++] = r : Re(r);
  }
  for (t = 0; t < n; t++)
    Re(e[t]);
}
function Oe(e, t) {
  e.state = 0;
  for (let n = 0; n < e.sources.length; n += 1) {
    const r = e.sources[n];
    if (r.sources) {
      const i = r.state;
      i === se ? r !== t && (!r.updatedAt || r.updatedAt < je) && Re(r) : i === Be && Oe(r, t);
    }
  }
}
function St(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const n = e.observers[t];
    n.state || (n.state = Be, n.pure ? X.push(n) : ce.push(n), n.observers && St(n));
  }
}
function ze(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const n = e.sources.pop(), r = e.sourceSlots.pop(), i = n.observers;
      if (i && i.length) {
        const l = i.pop(), o = n.observerSlots.pop();
        r < i.length && (l.sourceSlots[o] = r, i[r] = l, n.observerSlots[r] = o);
      }
    }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--)
      ze(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--)
      e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function cn(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function Et(e, t = U) {
  throw cn(e);
}
const un = Symbol("fallback");
function ot(e) {
  for (let t = 0; t < e.length; t++)
    e[t]();
}
function dn(e, t, n = {}) {
  let r = [], i = [], l = [], o = 0, s = t.length > 1 ? [] : null;
  return Ge(() => ot(l)), () => {
    let c = e() || [], u, a;
    return c[$t], Q(() => {
      let d = c.length, $, v, b, A, z, B, m, p, S;
      if (d === 0)
        o !== 0 && (ot(l), l = [], r = [], i = [], o = 0, s && (s = [])), n.fallback && (r = [un], i[0] = Pe((C) => (l[0] = C, n.fallback())), o = 1);
      else if (o === 0) {
        for (i = new Array(d), a = 0; a < d; a++)
          r[a] = c[a], i[a] = Pe(f);
        o = d;
      } else {
        for (b = new Array(d), A = new Array(d), s && (z = new Array(d)), B = 0, m = Math.min(o, d); B < m && r[B] === c[B]; B++)
          ;
        for (m = o - 1, p = d - 1; m >= B && p >= B && r[m] === c[p]; m--, p--)
          b[p] = i[m], A[p] = l[m], s && (z[p] = s[m]);
        for ($ = /* @__PURE__ */ new Map(), v = new Array(p + 1), a = p; a >= B; a--)
          S = c[a], u = $.get(S), v[a] = u === void 0 ? -1 : u, $.set(S, a);
        for (u = B; u <= m; u++)
          S = r[u], a = $.get(S), a !== void 0 && a !== -1 ? (b[a] = i[u], A[a] = l[u], s && (z[a] = s[u]), a = v[a], $.set(S, a)) : l[u]();
        for (a = B; a < d; a++)
          a in b ? (i[a] = b[a], l[a] = A[a], s && (s[a] = z[a], s[a](a))) : i[a] = Pe(f);
        i = i.slice(0, o = d), r = c.slice(0);
      }
      return i;
    });
    function f(d) {
      if (l[a] = d, s) {
        const [$, v] = M(a);
        return s[a] = v, t(c[a], $);
      }
      return t(c[a]);
    }
  };
}
function _(e, t) {
  return Q(() => e(t || {}));
}
function ke() {
  return !0;
}
const fn = {
  get(e, t, n) {
    return t === Ve ? n : e.get(t);
  },
  has(e, t) {
    return t === Ve ? !0 : e.has(t);
  },
  set: ke,
  deleteProperty: ke,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: ke,
      deleteProperty: ke
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function Ne(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function hn() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const n = this[e]();
    if (n !== void 0)
      return n;
  }
}
function ie(...e) {
  let t = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    t = t || !!s && Ve in s, e[o] = typeof s == "function" ? (t = !0, L(s)) : s;
  }
  if (t)
    return new Proxy({
      get(o) {
        for (let s = e.length - 1; s >= 0; s--) {
          const c = Ne(e[s])[o];
          if (c !== void 0)
            return c;
        }
      },
      has(o) {
        for (let s = e.length - 1; s >= 0; s--)
          if (o in Ne(e[s]))
            return !0;
        return !1;
      },
      keys() {
        const o = [];
        for (let s = 0; s < e.length; s++)
          o.push(...Object.keys(Ne(e[s])));
        return [...new Set(o)];
      }
    }, fn);
  const n = {}, r = /* @__PURE__ */ Object.create(null);
  for (let o = e.length - 1; o >= 0; o--) {
    const s = e[o];
    if (!s)
      continue;
    const c = Object.getOwnPropertyNames(s);
    for (let u = c.length - 1; u >= 0; u--) {
      const a = c[u];
      if (a === "__proto__" || a === "constructor")
        continue;
      const f = Object.getOwnPropertyDescriptor(s, a);
      if (!r[a])
        r[a] = f.get ? {
          enumerable: !0,
          configurable: !0,
          get: hn.bind(n[a] = [f.get.bind(s)])
        } : f.value !== void 0 ? f : void 0;
      else {
        const d = n[a];
        d && (f.get ? d.push(f.get.bind(s)) : f.value !== void 0 && d.push(() => f.value));
      }
    }
  }
  const i = {}, l = Object.keys(r);
  for (let o = l.length - 1; o >= 0; o--) {
    const s = l[o], c = r[s];
    c && c.get ? Object.defineProperty(i, s, c) : i[s] = c ? c.value : void 0;
  }
  return i;
}
const gn = (e) => `Stale read from <${e}>.`;
function fe(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return L(dn(() => e.each, e.children, t || void 0));
}
function k(e) {
  const t = e.keyed, n = L(() => e.when, void 0, {
    equals: (r, i) => t ? r === i : !r == !i
  });
  return L(() => {
    const r = n();
    if (r) {
      const i = e.children;
      return typeof i == "function" && i.length > 0 ? Q(() => i(t ? r : () => {
        if (!Q(n))
          throw gn("Show");
        return e.when;
      })) : i;
    }
    return e.fallback;
  }, void 0, void 0);
}
function vn(e, t, n) {
  let r = n.length, i = t.length, l = r, o = 0, s = 0, c = t[i - 1].nextSibling, u = null;
  for (; o < i || s < l; ) {
    if (t[o] === n[s]) {
      o++, s++;
      continue;
    }
    for (; t[i - 1] === n[l - 1]; )
      i--, l--;
    if (i === o) {
      const a = l < r ? s ? n[s - 1].nextSibling : n[l - s] : c;
      for (; s < l; )
        e.insertBefore(n[s++], a);
    } else if (l === s)
      for (; o < i; )
        (!u || !u.has(t[o])) && t[o].remove(), o++;
    else if (t[o] === n[l - 1] && n[s] === t[i - 1]) {
      const a = t[--i].nextSibling;
      e.insertBefore(n[s++], t[o++].nextSibling), e.insertBefore(n[--l], a), t[i] = n[l];
    } else {
      if (!u) {
        u = /* @__PURE__ */ new Map();
        let f = s;
        for (; f < l; )
          u.set(n[f], f++);
      }
      const a = u.get(t[o]);
      if (a != null)
        if (s < a && a < l) {
          let f = o, d = 1, $;
          for (; ++f < i && f < l && !(($ = u.get(t[f])) == null || $ !== a + d); )
            d++;
          if (d > a - s) {
            const v = t[o];
            for (; s < a; )
              e.insertBefore(n[s++], v);
          } else
            e.replaceChild(n[s++], t[o++]);
        } else
          o++;
      else
        t[o++].remove();
    }
  }
}
const at = "_$DX_DELEGATE";
function w(e, t, n) {
  let r;
  const i = () => {
    const o = document.createElement("template");
    return o.innerHTML = e, n ? o.content.firstChild.firstChild : o.content.firstChild;
  }, l = t ? () => Q(() => document.importNode(r || (r = i()), !0)) : () => (r || (r = i())).cloneNode(!0);
  return l.cloneNode = l, l;
}
function kt(e, t = window.document) {
  const n = t[at] || (t[at] = /* @__PURE__ */ new Set());
  for (let r = 0, i = e.length; r < i; r++) {
    const l = e[r];
    n.has(l) || (n.add(l), t.addEventListener(l, mn));
  }
}
function N(e, t, n) {
  n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function h(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Fe(e, t, n) {
  if (!t)
    return n ? N(e, "style") : t;
  const r = e.style;
  if (typeof t == "string")
    return r.cssText = t;
  typeof n == "string" && (r.cssText = n = void 0), n || (n = {}), t || (t = {});
  let i, l;
  for (l in n)
    t[l] == null && r.removeProperty(l), delete n[l];
  for (l in t)
    i = t[l], i !== n[l] && (r.setProperty(l, i), n[l] = i);
  return n;
}
function J(e, t, n) {
  return Q(() => e(t, n));
}
function g(e, t, n, r) {
  if (n !== void 0 && !r && (r = []), typeof t != "function")
    return Me(e, t, r, n);
  R((i) => Me(e, t(), i, n), r);
}
function mn(e) {
  const t = `$$${e.type}`;
  let n = e.composedPath && e.composedPath()[0] || e.target;
  for (e.target !== n && Object.defineProperty(e, "target", {
    configurable: !0,
    value: n
  }), Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return n || document;
    }
  }); n; ) {
    const r = n[t];
    if (r && !n.disabled) {
      const i = n[`${t}Data`];
      if (i !== void 0 ? r.call(n, i, e) : r.call(n, e), e.cancelBubble)
        return;
    }
    n = n._$host || n.parentNode || n.host;
  }
}
function Me(e, t, n, r, i) {
  for (; typeof n == "function"; )
    n = n();
  if (t === n)
    return n;
  const l = typeof t, o = r !== void 0;
  if (e = o && n[0] && n[0].parentNode || e, l === "string" || l === "number")
    if (l === "number" && (t = t.toString()), o) {
      let s = n[0];
      s && s.nodeType === 3 ? s.data !== t && (s.data = t) : s = document.createTextNode(t), n = be(e, n, r, s);
    } else
      n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
  else if (t == null || l === "boolean")
    n = be(e, n, r);
  else {
    if (l === "function")
      return R(() => {
        let s = t();
        for (; typeof s == "function"; )
          s = s();
        n = Me(e, s, n, r);
      }), () => n;
    if (Array.isArray(t)) {
      const s = [], c = n && Array.isArray(n);
      if (Ke(s, t, n, i))
        return R(() => n = Me(e, s, n, r, !0)), () => n;
      if (s.length === 0) {
        if (n = be(e, n, r), o)
          return n;
      } else
        c ? n.length === 0 ? ct(e, s, r) : vn(e, n, s) : (n && be(e), ct(e, s));
      n = s;
    } else if (t.nodeType) {
      if (Array.isArray(n)) {
        if (o)
          return n = be(e, n, r, t);
        be(e, n, null, t);
      } else
        n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      n = t;
    }
  }
  return n;
}
function Ke(e, t, n, r) {
  let i = !1;
  for (let l = 0, o = t.length; l < o; l++) {
    let s = t[l], c = n && n[l], u;
    if (!(s == null || s === !0 || s === !1))
      if ((u = typeof s) == "object" && s.nodeType)
        e.push(s);
      else if (Array.isArray(s))
        i = Ke(e, s, c) || i;
      else if (u === "function")
        if (r) {
          for (; typeof s == "function"; )
            s = s();
          i = Ke(e, Array.isArray(s) ? s : [s], Array.isArray(c) ? c : [c]) || i;
        } else
          e.push(s), i = !0;
      else {
        const a = String(s);
        c && c.nodeType === 3 && c.data === a ? e.push(c) : e.push(document.createTextNode(a));
      }
  }
  return i;
}
function ct(e, t, n = null) {
  for (let r = 0, i = t.length; r < i; r++)
    e.insertBefore(t[r], n);
}
function be(e, t, n, r) {
  if (n === void 0)
    return e.textContent = "";
  const i = r || document.createTextNode("");
  if (t.length) {
    let l = !1;
    for (let o = t.length - 1; o >= 0; o--) {
      const s = t[o];
      if (i !== s) {
        const c = s.parentNode === e;
        !l && !o ? c ? e.replaceChild(i, s) : e.insertBefore(i, n) : c && s.remove();
      } else
        l = !0;
    }
  } else
    e.insertBefore(i, n);
  return [i];
}
function _n(e) {
  const t = Object.keys(e), n = {};
  for (let r = 0; r < t.length; r++) {
    const [i, l] = M(e[t[r]]);
    Object.defineProperty(n, t[r], {
      get: i,
      set(o) {
        l(() => o);
      }
    });
  }
  return n;
}
function $n(e) {
  if (e.assignedSlot && e.assignedSlot._$owner)
    return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function bn(e) {
  return (t, n) => {
    const { element: r } = n;
    return Pe((i) => {
      const l = _n(t);
      r.addPropertyChangedCallback((s, c) => l[s] = c), r.addReleaseCallback(() => {
        r.renderRoot.textContent = "", i();
      });
      const o = e(l, n);
      return g(r.renderRoot, o);
    }, $n(r));
  };
}
function ye(e, t, n) {
  return arguments.length === 2 && (n = t, t = {}), Jt(e, t)(bn(n));
}
const Tt = {
  classBlock: "livestream-block",
  customElement: !1,
  themes: {
    block: "light",
    viewer: "dark"
  },
  timer: {
    headline: "",
    set: null
  }
}, pn = (e) => !!e && e.constructor === Object, At = (e) => typeof e == "string" || e instanceof String, ut = ({ delay: e }, t) => {
  let n, r = !0;
  const i = (...l) => {
    r ? (clearTimeout(n), n = setTimeout(() => {
      r && t(...l), n = void 0;
    }, e)) : t(...l);
  };
  return i.isPending = () => n !== void 0, i.cancel = () => {
    r = !1;
  }, i.flush = (...l) => t(...l), i;
}, wn = (e, t) => {
  if (!e)
    return [];
  const n = Object.entries(e);
  return n.length === 0 ? [] : n.reduce((r, i) => (r.push(t(i[0], i[1])), r), []);
}, Pt = (e) => {
  if (!e || e.length === 0)
    return "";
  const t = e.toLowerCase();
  return t.substring(0, 1).toUpperCase() + t.substring(1, t.length);
}, yn = (e) => {
  const t = e?.replace(/([A-Z])+/g, Pt)?.split(/(?=[A-Z])|[\.\-\s_]/).map((n) => n.toLowerCase()) ?? [];
  return t.length === 0 ? "" : t.length === 1 ? t[0] : t.reduce((n, r) => `${n}${r.charAt(0).toUpperCase()}${r.slice(1)}`);
}, Xe = (e, t) => {
  const n = e.parentNode;
  n && [...n.attributes].forEach((r) => {
    Object.keys(t).includes(r.name) && n.removeAttribute(r.name);
  });
}, Se = (e) => {
  const t = {};
  for (const n in e)
    e.hasOwnProperty(n) && (t[yn(n)] = e[n]);
  return t;
}, Lt = {
  autoStart: !0,
  classBlock: "countdown-timer",
  customElement: !1,
  digits: !1,
  display: {
    days: !0,
    hours: !0,
    minutes: !0,
    seconds: !0,
    milliseconds: !1
  },
  id: "timer",
  interval: 1e3,
  onComplete: () => {
  },
  onTick: () => {
  },
  ref: null,
  seperator: ":",
  targetTime: null
}, Bt = /* @__PURE__ */ new Set(["days", "hours", "minutes", "seconds"]), Cn = (e) => pn(e) && Object.keys(e).some((t) => Bt.has(t)), xn = (e) => {
  if (At(e))
    return new Date(e).getTime();
  if (Cn(e)) {
    const { days: t = 0, hours: n = 0, minutes: r = 0, seconds: i = 0, milliseconds: l = 0 } = e;
    return (t * 24 * 60 * 60 + n * 60 * 60 + r * 60 + i) * 1e3 + l;
  }
  throw new Error("Invalid date");
}, Sn = (e) => {
  const t = e % 1e3, n = Math.floor(e / 1e3) % 60, r = Math.floor(e / (1e3 * 60)) % 60, i = Math.floor(e / (1e3 * 60 * 60)) % 24;
  return {
    days: Math.floor(e / (1e3 * 60 * 60 * 24)),
    hours: i,
    minutes: r,
    seconds: n,
    milliseconds: t
  };
}, En = (e, t, n) => (e - t) / (n - t), Te = (e, t = 2) => e.toString().padStart(t, "0"), kn = (e) => {
  const { days: t, hours: n, minutes: r, seconds: i } = e;
  return {
    days: Te(t),
    hours: Te(n),
    minutes: Te(r),
    seconds: Te(i),
    milliseconds: e.milliseconds.toString()
  };
};
var Tn = /* @__PURE__ */ w("<div part=root>"), An = /* @__PURE__ */ w("<div><div part=segment-label></div><div part=segment-value><span>"), Pn = /* @__PURE__ */ w("<div part=separator>"), Ln = /* @__PURE__ */ w("<div aria-hidden=true part=digit><div part=digit-set>0 1 2 3 4 5 6 7 8 9");
const Ye = (e) => {
  e = ie(Lt, e), e.customElement && we();
  let t, n;
  const r = L(() => e.targetTime ? xn(e.targetTime) : null), [i, l] = M(!1), [o, s] = M(0), c = L(() => Sn(o())), u = L(() => kn(c())), a = L(() => {
    const m = r();
    return m === null ? 0 : En(o(), m, 0);
  }), f = L(() => o() <= 0), d = (m) => {
    e.onTick?.(m), n.dispatchEvent(new CustomEvent("timer-tick", {
      detail: m,
      bubbles: !0
    }));
  }, $ = (m) => {
    e.onComplete?.(m), n.dispatchEvent(new CustomEvent("timer-complete", {
      detail: m,
      bubbles: !0
    }));
  }, v = () => {
    s(o() + -1 * e.interval);
  }, b = () => {
    l(!1), s(0);
  }, A = () => {
    b(), clearInterval(t);
  }, z = () => {
    i() || (l(!0), v(), t = setInterval(() => {
      const m = {
        time: c(),
        formattedTime: u(),
        progress: a()
      };
      v(), d(m), o() < 1 && (A(), $(m));
    }, e.interval));
  }, B = () => {
    i() && (l(!1), clearInterval(t));
  };
  return he(() => {
    s(r() - Date.now()), e.autoStart && z(), e.ref?.({
      pause: B,
      play: z,
      time: c,
      formattedTime: u,
      progressPercent: a
    });
  }), (() => {
    var m = Tn(), p = n;
    return typeof p == "function" ? J(p, m) : n = m, g(m, _(fe, {
      get each() {
        return Object.keys(u());
      },
      children: (S, C) => _(k, {
        get when() {
          return e.display[S];
        },
        get children() {
          return [(() => {
            var x = An(), F = x.firstChild, D = F.nextSibling, E = D.firstChild;
            return N(x, "part", `segment segment-${S}`), g(F, () => Pt(S)), g(E, () => u()[S]), g(D, _(k, {
              get when() {
                return e.digits;
              },
              get children() {
                return _(fe, {
                  get each() {
                    return u()[S].split("");
                  },
                  children: (y, I) => (() => {
                    var W = Ln(), le = W.firstChild;
                    return R((T) => {
                      var O = `${e.classBlock}__digit`, K = `--digit: ${y}`, P = `${e.classBlock}__digit-set`;
                      return O !== T.e && h(W, T.e = O), T.t = Fe(W, K, T.t), P !== T.a && h(le, T.a = P), T;
                    }, {
                      e: void 0,
                      t: void 0,
                      a: void 0
                    }), W;
                  })()
                });
              }
            }), null), R((y) => {
              var I = `${e.classBlock}__segment`, W = `${e.classBlock}__segment-label`, le = `${e.classBlock}__segment-value`, T = `--value: ${u()[S]}`;
              return I !== y.e && h(x, y.e = I), W !== y.t && h(F, y.t = W), le !== y.a && h(D, y.a = le), y.o = Fe(D, T, y.o), y;
            }, {
              e: void 0,
              t: void 0,
              a: void 0,
              o: void 0
            }), x;
          })(), _(k, {
            get when() {
              return C() !== Bt.size - 1 && e.seperator !== !1;
            },
            get children() {
              var x = Pn();
              return g(x, () => e.seperator), R(() => h(x, `${e.classBlock}__separator`)), x;
            }
          })];
        }
      })
    })), R((S) => {
      var C = `${e.classBlock}__root`, x = i() ? "running" : "paused", F = f() ? "true" : "false";
      return C !== S.e && h(m, S.e = C), x !== S.t && N(m, "data-state", S.t = x), F !== S.a && N(m, "data-complete", S.a = F), S;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), m;
  })();
};
var Bn = /* @__PURE__ */ w("<h3>"), Rn = /* @__PURE__ */ w('<div part=viewer><div><div><svg class="icon icon--university-seal university-seal__svg"height=72 width=72><use href=#university-seal>');
const On = (e) => {
  e = ie(Tt, e);
  const {
    classBlock: t,
    customElement: n,
    themes: r,
    timer: i
  } = e;
  n && we();
  let l;
  return he(() => {
    Xe(l, e);
  }), (() => {
    var o = Rn(), s = o.firstChild, c = s.firstChild;
    return J((u) => l = u, o), J((u) => u, s), h(s, `${t}__viewer-inner`), h(c, `${t}__viewer-graphic university-seal`), g(s, _(k, {
      get when() {
        return i?.headline;
      },
      get children() {
        var u = Bn();
        return h(u, `${t}__timer-headline`), g(u, () => i.headline), u;
      }
    }), null), g(s, _(Ye, {
      class: `${t}__countdown-timer countdown-timer`,
      get targetTime() {
        return i.set;
      }
    }), null), R(() => h(o, `${t}__viewer theme--${r.viewer}`)), o;
  })();
}, jr = ye("livestream-countdown", { ...Tt, customElement: !0 }, On);
var He = () => {
}, dt = (e, t) => t();
function Mn(e, t) {
  const n = Q(e), r = n ? [n] : [], { onEnter: i = dt, onExit: l = dt } = t, [o, s] = M(
    t.appear ? [] : r
  ), [c] = wt();
  let u, a = !1;
  function f(v, b) {
    if (!v)
      return b && b();
    a = !0, l(v, () => {
      lt(() => {
        a = !1, s((A) => A.filter((z) => z !== v)), b && b();
      });
    });
  }
  function d(v) {
    const b = u;
    if (!b)
      return v && v();
    u = void 0, s((A) => [b, ...A]), i(b, v ?? He);
  }
  const $ = t.mode === "out-in" ? (
    // exit -> enter
    (v) => a || f(v, d)
  ) : t.mode === "in-out" ? (
    // enter -> exit
    (v) => d(() => f(v))
  ) : (
    // exit & enter
    (v) => {
      f(v), d();
    }
  );
  return en(
    (v) => {
      const b = e();
      return Q(c) ? (c(), v) : (b !== v && (u = b, lt(() => Q(() => $(v)))), b);
    },
    t.appear ? void 0 : n
  ), o;
}
function In(e, t) {
  const n = Q(e), { onChange: r } = t;
  let i = new Set(t.appear ? void 0 : n);
  const l = /* @__PURE__ */ new WeakSet(), [o, s] = M([], { equals: !1 }), [c] = wt(), u = t.exitMethod === "remove" ? He : (f) => {
    s((d) => (d.push.apply(d, f), d));
    for (const d of f)
      l.delete(d);
  }, a = t.exitMethod === "remove" ? He : t.exitMethod === "keep-index" ? (f, d, $) => f.splice($, 0, d) : (f, d) => f.push(d);
  return L(
    (f) => {
      const d = o(), $ = e();
      if ($[$t], Q(c))
        return c(), f;
      if (d.length) {
        const v = f.filter((b) => !d.includes(b));
        return d.length = 0, r({ list: v, added: [], removed: [], unchanged: v, finishRemoved: u }), v;
      }
      return Q(() => {
        const v = new Set($), b = $.slice(), A = [], z = [], B = [];
        for (const p of $)
          (i.has(p) ? B : A).push(p);
        let m = !A.length;
        for (let p = 0; p < f.length; p++) {
          const S = f[p];
          v.has(S) || (l.has(S) || (z.push(S), l.add(S)), a(b, S, p)), m && S !== b[p] && (m = !1);
        }
        return !z.length && m ? f : (r({ list: b, added: A, removed: z, unchanged: B, finishRemoved: u }), i = v, b);
      });
    },
    t.appear ? [] : n.slice()
  );
}
var Ie = (e) => e instanceof Element;
function Ue(e, t) {
  if (t(e))
    return e;
  if (typeof e == "function" && !e.length)
    return Ue(e(), t);
  if (Array.isArray(e)) {
    const n = [];
    for (const r of e) {
      const i = Ue(r, t);
      i && (Array.isArray(i) ? n.push.apply(n, i) : n.push(i));
    }
    return n.length ? n : null;
  }
  return null;
}
function jn(e, t = Ie, n = Ie) {
  const r = L(e), i = L(
    () => Ue(r(), t)
  );
  return i.toArray = () => {
    const l = i();
    return Array.isArray(l) ? l : l ? [l] : [];
  }, i;
}
function qe(e, t) {
  if (t(e))
    return e;
  if (typeof e == "function" && !e.length)
    return qe(e(), t);
  if (Array.isArray(e))
    for (const n of e) {
      const r = qe(n, t);
      if (r)
        return r;
    }
  return null;
}
function zn(e, t = Ie, n = Ie) {
  const r = L(e);
  return L(() => qe(r(), t));
}
function Rt(e) {
  return L(() => {
    const t = e.name || "s";
    return {
      enterActive: (e.enterActiveClass || t + "-enter-active").split(" "),
      enter: (e.enterClass || t + "-enter").split(" "),
      enterTo: (e.enterToClass || t + "-enter-to").split(" "),
      exitActive: (e.exitActiveClass || t + "-exit-active").split(" "),
      exit: (e.exitClass || t + "-exit").split(" "),
      exitTo: (e.exitToClass || t + "-exit-to").split(" "),
      move: (e.moveClass || t + "-move").split(" ")
    };
  });
}
function Ot(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
function Mt(e, t, n, r) {
  const { onBeforeEnter: i, onEnter: l, onAfterEnter: o } = t;
  i?.(n), n.classList.add(...e.enter), n.classList.add(...e.enterActive), queueMicrotask(() => {
    if (!n.parentNode)
      return r?.();
    l?.(n, () => s());
  }), Ot(() => {
    n.classList.remove(...e.enter), n.classList.add(...e.enterTo), (!l || l.length < 2) && (n.addEventListener("transitionend", s), n.addEventListener("animationend", s));
  });
  function s(c) {
    (!c || c.target === n) && (r?.(), n.removeEventListener("transitionend", s), n.removeEventListener("animationend", s), n.classList.remove(...e.enterActive), n.classList.remove(...e.enterTo), o?.(n));
  }
}
function It(e, t, n, r) {
  const { onBeforeExit: i, onExit: l, onAfterExit: o } = t;
  if (!n.parentNode)
    return r?.();
  i?.(n), n.classList.add(...e.exit), n.classList.add(...e.exitActive), l?.(n, () => s()), Ot(() => {
    n.classList.remove(...e.exit), n.classList.add(...e.exitTo), (!l || l.length < 2) && (n.addEventListener("transitionend", s), n.addEventListener("animationend", s));
  });
  function s(c) {
    (!c || c.target === n) && (r?.(), n.removeEventListener("transitionend", s), n.removeEventListener("animationend", s), n.classList.remove(...e.exitActive), n.classList.remove(...e.exitTo), o?.(n));
  }
}
var Dn = {
  inout: "in-out",
  outin: "out-in"
}, Nn = (e) => {
  const t = Rt(e);
  return Mn(
    zn(() => e.children),
    {
      mode: Dn[e.mode],
      appear: e.appear,
      onEnter(n, r) {
        Mt(t(), e, n, r);
      },
      onExit(n, r) {
        It(t(), e, n, r);
      }
    }
  );
}, Vn = (e) => {
  const t = Rt(e);
  return In(jn(() => e.children).toArray, {
    appear: e.appear,
    exitMethod: "keep-index",
    onChange({ added: n, removed: r, finishRemoved: i, list: l }) {
      const o = t();
      for (const c of n)
        Mt(o, e, c);
      const s = [];
      for (const c of l)
        c.isConnected && (c instanceof HTMLElement || c instanceof SVGElement) && s.push({ el: c, rect: c.getBoundingClientRect() });
      queueMicrotask(() => {
        const c = [];
        for (const { el: u, rect: a } of s)
          if (u.isConnected) {
            const f = u.getBoundingClientRect(), d = a.left - f.left, $ = a.top - f.top;
            (d || $) && (u.style.transform = `translate(${d}px, ${$}px)`, u.style.transitionDuration = "0s", c.push(u));
          }
        document.body.offsetHeight;
        for (const u of c) {
          let a = function(f) {
            (f.target === u || /transform$/.test(f.propertyName)) && (u.removeEventListener("transitionend", a), u.classList.remove(...o.move));
          };
          u.classList.add(...o.move), u.style.transform = u.style.transitionDuration = "", u.addEventListener("transitionend", a);
        }
      });
      for (const c of r)
        It(o, e, c, () => i([c]));
    }
  });
}, Fn = /* @__PURE__ */ w("<span class=button__icon><svg height=24 width=24><use>"), Kn = /* @__PURE__ */ w("<a><span>");
const ft = ({
  title: e,
  url: t,
  target: n = "",
  icon: r,
  style: i = "outline",
  cardBlock: l
}) => (() => {
  var o = Kn(), s = o.firstChild;
  return N(o, "href", t), N(o, "target", n), h(o, `button -style-${i} ${l ? `${l}__button` : ""}`), g(s, e), g(o, _(k, {
    when: r,
    get children() {
      var c = Fn(), u = c.firstChild, a = u.firstChild;
      return N(u, "class", `icon icon--${r}`), N(a, "href", `#icon-${r}`), c;
    }
  }), null), o;
})(), We = (e) => typeof e == "function" ? e() : e, jt = typeof window < "u" ? window : void 0, zt = (e, t, n = {}) => {
  const { window: r = jt, ...i } = n;
  let l;
  const o = () => {
    l && (l.disconnect(), l = void 0);
  }, s = L(() => Array.isArray(e) ? e.map(We) : [We(e)]);
  return pe(() => {
    l = new ResizeObserver(t);
    for (const c of s())
      c && l.observe(c, i);
  }, s), Ge(o), o;
}, Dt = (e, t = {}) => {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: i = !0,
    immediate: l = !0,
    cssVars: o = !0,
    cssVarsPrefix: s = "--element-bounding-",
    observedContainer: c = "element",
    size: u = !0,
    position: a = !0,
    inset: f = !0
  } = t, d = {
    element: e ?? null,
    parent: e?.parentElement ?? null,
    window: jt ?? null
  }, [$, v] = M(0), [b, A] = M(0), [z, B] = M(0), [m, p] = M(0), [S, C] = M(0), [x, F] = M(0), [D, E] = M(0), [y, I] = M(0), W = () => {
    v(0), A(0), B(0), p(0), C(0), F(0), E(0), I(0);
  }, le = (O) => {
    const K = O.getBoundingClientRect();
    u && O.style.setProperty(`${s}block-size`, `${K.height}px`), u && O.style.setProperty(`${s}inline-size`, `${K.width}px`), f && O.style.setProperty(`${s}inset-block-start`, `${K.top}px`), f && O.style.setProperty(`${s}inset-block-end`, `${K.bottom}px`), f && O.style.setProperty(`${s}inset-inline-start`, `${K.left}px`), f && O.style.setProperty(`${s}inset-inline-end`, `${K.right}px`), a && O.style.setProperty(`${s}position-x`, `${K.x}px`), a && O.style.setProperty(`${s}position-y`, `${K.y}px`);
  }, T = () => {
    const O = We(e);
    if (!O) {
      n && W();
      return;
    }
    const K = O.getBoundingClientRect();
    v(K.height), A(K.bottom), B(K.left), p(K.right), C(K.top), F(K.width), E(K.x), I(K.y), o && le(O);
  };
  return he(() => {
    l && T(), zt(d[c], T), i && window.addEventListener("scroll", T, { capture: !0, passive: !0 }), r && window.addEventListener("resize", T, { capture: !0 });
  }), { height: $, bottom: b, left: z, right: m, top: S, width: x, x: D, y, update: T };
};
var Hn = /* @__PURE__ */ w('<div class="event-card__eyebrow tag">'), Un = /* @__PURE__ */ w("<div class=event-card__subtitle>"), qn = /* @__PURE__ */ w("<div class=event-card__day>"), Wn = /* @__PURE__ */ w("<div class=event-card__time>"), Zn = /* @__PURE__ */ w("<div class=event-card__location>"), Gn = /* @__PURE__ */ w("<div class=event-card__meta>"), Xn = /* @__PURE__ */ w("<div class=event-card__summary>"), Yn = /* @__PURE__ */ w('<div class=event-card__footer><div class="event-card__actions actions">'), Jn = /* @__PURE__ */ w("<article class=event-card><div class=event-card__content><div class=event-card__headline><h3 class=event-card__title>");
const Ze = ({
  day: e,
  showDay: t,
  noBounding: n,
  audience: r,
  title: i,
  subtitle: l,
  time: o,
  location: s,
  summary: c,
  mapUrl: u,
  learnMoreLink: a,
  showLearnMoreLinkInModal: f = !0,
  isModal: d = !1,
  index: $ = 0
}) => {
  let v = null;
  return he(() => {
    n || setTimeout(() => {
      Dt(v, {
        cssVarsPrefix: "--event-card-",
        observedContainer: "parent"
      });
    }, 250);
  }), (() => {
    var b = Jn(), A = b.firstChild, z = A.firstChild, B = z.firstChild;
    return J((m) => v = m, b), g(A, _(k, {
      when: r,
      get children() {
        var m = Hn();
        return g(m, r), m;
      }
    }), z), g(B, i), g(z, _(k, {
      when: l,
      get children() {
        var m = Un();
        return g(m, l), m;
      }
    }), null), g(A, _(k, {
      when: o || s,
      get children() {
        var m = Gn();
        return g(m, _(k, {
          when: e && t,
          get children() {
            var p = qn();
            return p.innerHTML = e, p;
          }
        }), null), g(m, _(k, {
          when: o,
          get children() {
            var p = Wn();
            return p.innerHTML = o, p;
          }
        }), null), g(m, _(k, {
          when: s,
          get children() {
            var p = Zn();
            return p.innerHTML = s, p;
          }
        }), null), m;
      }
    }), null), g(A, _(k, {
      when: c,
      get children() {
        var m = Xn();
        return m.innerHTML = c, m;
      }
    }), null), g(b, _(k, {
      when: u || a,
      get children() {
        var m = Yn(), p = m.firstChild;
        return g(p, _(k, {
          when: u,
          get children() {
            return _(ft, {
              title: "View Map",
              url: u,
              target: "_blank",
              icon: "map",
              cardBlock: "event-card"
            });
          }
        }), null), g(p, _(k, {
          when: a && !d || a && d && f,
          get children() {
            return _(ft, {
              get title() {
                return a.title;
              },
              get url() {
                return a.url;
              },
              get target() {
                return a.target;
              },
              icon: "circle-arrow-right",
              style: "accent",
              cardBlock: "event-card"
            });
          }
        }), null), m;
      }
    }), null), R((m) => Fe(b, `--event-card-index: ${$};`, m)), b;
  })();
}, Nt = {
  callout: null,
  classBlock: "events",
  classes: "",
  customElement: !1,
  data: null,
  id: "events",
  initialSelectedTabIndex: 0,
  mobileBreakpoint: 768,
  ref: null,
  tabs: [],
  tabletBreakpoint: 1120
}, Qn = {
  activeClass: "has--active-indicator",
  childrenRef: null,
  focusedChildClass: "is--focused-child",
  focusedIndicator: !0,
  indicatorClass: "nav-indicator",
  parentRef: null,
  selectedChildSlug: null,
  selectedChildClass: "is--selected-child",
  selectedIndicator: !0
};
var ht = /* @__PURE__ */ w("<div role=presentation>");
const er = (e) => {
  e = ie(Qn, e);
  let t = e.childrenRef.filter((C) => C.dataset.tab), n = 250, r = null, i = null;
  const [l, o] = M(!1), [s, c] = M({}), [u, a] = M(null), [f, d] = M(null), $ = L(() => s()[e.selectedChildSlug] ? e.selectedChildSlug : null), v = (C) => {
    const x = {};
    return Array.from(C).forEach((D) => {
      x[D.dataset.tab] = {
        ref: D,
        position: {
          x: null,
          y: null
        },
        size: {
          block: null,
          inline: null
        }
      };
    }), c(x), x;
  }, b = (C) => {
    Array.isArray(C) && C.forEach((x) => {
      const F = x.target.dataset.tab;
      c((D) => {
        if (D[F])
          return D[F].position.x = x.target.offsetLeft, D[F].position.y = x.target.offsetTop, x.borderBoxSize && (D[F].size.inline = x.borderBoxSize[0].inlineSize, D[F].size.block = x.borderBoxSize[0].blockSize), D;
      });
    });
  }, A = (C, x) => {
    if (!C)
      return;
    const F = At(C) ? C : C.dataset.tab, {
      position: D,
      size: E
    } = s()[F];
    requestAnimationFrame(() => {
      x.style.setProperty("--indicator-inset-block-start", `${D.y}px`), x.style.setProperty("--indicator-inset-inline-start", `${D.x}px`), x.style.setProperty("--indicator-block-size", `${E.block}px`), x.style.setProperty("--indicator-inline-size", `${E.inline}px`);
    });
  }, z = () => {
    o(!0), e.parentRef.classList.add(e.activeClass);
  }, B = () => {
    o(!1), e.parentRef.classList.remove(e.activeClass);
  }, m = (C) => {
    n !== 0 && (n = 0), A(C.detail, i), d(C.detail);
  }, p = (C) => {
    const x = C?.target ?? null;
    a(x), A(x, r);
  }, S = () => {
    t.forEach((C) => {
      C.addEventListener("focusin", p), C.addEventListener("mouseover", p);
    }), e.parentRef.addEventListener("mouseenter", z), e.parentRef.addEventListener("mouseleave", B), e.parentRef.addEventListener("focusin", z), e.parentRef.addEventListener("focusout", B), e.parentRef.addEventListener("tab-updated", m);
  };
  return he(() => {
    v(t), zt(t, b), S();
  }), pe(() => {
    setTimeout(() => {
      d($()), A($(), i);
    }, n);
  }), [_(k, {
    get when() {
      return e.focusedIndicator;
    },
    get children() {
      var C = ht();
      return J((x) => r = x, C), R(() => h(C, `${e.indicatorClass}`)), C;
    }
  }), _(k, {
    get when() {
      return e.selectedIndicator;
    },
    get children() {
      var C = ht();
      return J((x) => i = x, C), R(() => h(C, `${e.indicatorClass} ${e.indicatorClass}--selected`)), C;
    }
  })];
}, tr = typeof window < "u" ? window : void 0, nr = (e = {}) => {
  const {
    window: t = tr,
    initialWidth: n = 0,
    initialHeight: r = 0,
    listenOrientation: i = !0,
    includeScrollbar: l = !0
  } = e, [o, s] = M(n), [c, u] = M(r), a = () => {
    t && (l ? (s(t.innerWidth), u(t.innerHeight)) : (s(t.document.documentElement.clientWidth), u(t.document.documentElement.clientHeight)));
  };
  return a(), he(() => {
    a();
  }), t.addEventListener("resize", ut({ delay: 250 }, a)), i && t.matchMedia("(orientation: portrait)").addEventListener("change", ut({ delay: 250 }, a)), [o, c];
};
var rr = /* @__PURE__ */ w('<div><label for=event-select><span>Filter by Day</span></label><div><select id=event-select></select><div><svg class="icon icon--chevron-down"height=24 width=24><use href=#icon-chevron-down>'), ir = /* @__PURE__ */ w("<option> - "), sr = /* @__PURE__ */ w('<div><div><span></span></div><div></div><div><a target=_blank><span></span><div><svg class="icon icon--circle-arrow-right"height=12 width=12><use href=#icon-circle-arrow-right>'), gt = /* @__PURE__ */ w("<div><div></div><div>"), lr = /* @__PURE__ */ w("<nav role=tablist><div><legend>Filter by Day</legend><ul>"), or = /* @__PURE__ */ w('<div><div><span></span></div><div><a target=_blank><span class=sr-only></span></a><tooltip tip-focus-within><div></div><div><svg class="icon icon--external-link"height=24 width=24><use href=#icon-external-link>'), ar = /* @__PURE__ */ w("<div><div><div></div></div><div>"), cr = /* @__PURE__ */ w("<li><label><input name=day type=radio><div><span></span><span>");
const ur = (e) => {
  e = ie(Nt, e);
  const {
    classBlock: t,
    classes: n,
    customElement: r,
    data: i,
    mobileBreakpoint: l,
    tabletBreakpoint: o,
    callout: s,
    tabs: c,
    initialSelectedTabIndex: u
  } = e;
  r && we();
  let a, f;
  const d = L(() => s ? Se(s) : null), $ = L(() => i.map((P) => ({
    day: P.day,
    events: P.events.map((q) => Se(q)),
    callout: P.callout
  }))), v = L(() => c ? wn(Se(c), (P, q) => ({
    ...q
  })) : null), b = L(() => {
    const P = $().map((q) => q.day.slug);
    return v().filter((q) => P.includes(q.slug));
  }), A = L(() => {
    const P = {};
    return $().forEach((q) => {
      P[q.day.slug] = q.events;
    }), P;
  }), [z, B] = M(v()[u].slug), [m, p] = M(A()[z()]);
  let S = null, C = [];
  const x = (P) => {
    B(P), p(A()[P]), S?.dispatchEvent(new CustomEvent("tab-updated", {
      detail: P
    }));
  }, F = tn(z), D = (P) => A()[P].length === 0, E = L(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches), [y, I] = nr(), W = L(() => y() > l), le = L(() => y() > l && y() <= o), T = L(() => y() <= l), O = () => (() => {
    var P = rr(), q = P.firstChild, ge = q.nextSibling, te = ge.firstChild, ve = te.nextSibling;
    return h(P, `${t}__event-select`), h(q, `${t}__event-select-label`), h(ge, `${t}__select select`), te.addEventListener("change", (V) => x(V.target.value)), h(te, `${t}__select-input`), g(te, _(fe, {
      get each() {
        return b();
      },
      children: (V, Y) => (() => {
        var ee = ir(), ne = ee.firstChild;
        return g(ee, () => V.label, ne), g(ee, () => V.date, null), R((j) => {
          var ue = F(V.slug), G = D(V.slug);
          return ue !== j.e && (ee.selected = j.e = ue), G !== j.t && (ee.disabled = j.t = G), j;
        }, {
          e: void 0,
          t: void 0
        }), R(() => ee.value = V.slug), ee;
      })()
    })), h(ve, `${t}__select-icon select__icon`), P;
  })(), K = () => (() => {
    var P = sr(), q = P.firstChild, ge = q.firstChild, te = q.nextSibling, ve = te.nextSibling, V = ve.firstChild, Y = V.firstChild, ee = Y.nextSibling;
    return h(P, `${t}__callout ${t}__callout--mobile`), h(q, `${t}__callout-eyebrow`), g(ge, () => d().eyebrow), h(te, `${t}__callout-dates`), g(te, _(fe, {
      get each() {
        return d().labels;
      },
      children: (ne, j) => (() => {
        var ue = gt(), G = ue.firstChild, oe = G.nextSibling;
        return h(ue, `${t}__callout-label`), h(G, `${t}__callout-label-text`), g(G, () => ne.label), h(oe, `${t}__callout-label-date`), g(oe, () => ne.date), ue;
      })()
    })), h(ve, `${t}__callout-footer`), h(V, `${t}__callout-inline-link`), g(Y, () => d().tooltipText), h(ee, `${t}__callout-inline-link-icon`), R(() => N(V, "href", d().buttonLink)), P;
  })();
  return he(() => {
    Xe(a, e), B(v()[u].slug), setTimeout(() => {
      Dt(f, {
        cssVarsPrefix: "--event-card-grid-",
        position: !1,
        inset: !1
      });
    }, 250);
  }), (() => {
    var P = ar(), q = P.firstChild, ge = q.firstChild, te = q.nextSibling, ve = a;
    return typeof ve == "function" ? J(ve, P) : a = P, h(P, `${t}__inner ${n}`), h(q, `${t}__header`), h(ge, `${t}__controls`), g(ge, _(k, {
      get when() {
        return W();
      },
      fallback: O,
      get children() {
        var V = lr(), Y = V.firstChild, ee = Y.firstChild, ne = ee.nextSibling;
        return h(V, `${t}__tabs`), h(Y, `${t}__tabs-fieldset`), h(ee, `${t}__tabs-legend sr-only`), J((j) => S = j, ne), h(ne, `${t}__tabs-list`), g(ne, _(fe, {
          get each() {
            return b();
          },
          children: (j, ue) => (() => {
            var G = cr(), oe = G.firstChild, ae = oe.firstChild, re = ae.nextSibling, me = re.firstChild, de = me.nextSibling;
            return J((Z) => C = [...C, Z], G), h(oe, `${t}__input`), ae.addEventListener("change", () => x(j.slug)), h(re, `${t}__tab-label`), h(me, `${t}__tab-label-text`), g(me, () => j.label), h(de, `${t}__tab-label-date`), g(de, () => j.date), R((Z) => {
              var Ce = D(j.slug) ? null : j.slug, Qe = `${t}__tabs-tab ${F(j.slug) ? `${t}__tabs-tab--active` : ""} ${D(j.slug) ? `${t}__tabs-tab--disabled` : ""}`, et = `day-${j.slug}`, tt = `day-${j.slug}`, nt = D(j.slug), rt = j.slug, it = D(j.slug) ? -1 : 0;
              return Ce !== Z.e && N(G, "data-tab", Z.e = Ce), Qe !== Z.t && h(G, Z.t = Qe), et !== Z.a && N(oe, "for", Z.a = et), tt !== Z.o && N(ae, "id", Z.o = tt), nt !== Z.i && (ae.disabled = Z.i = nt), rt !== Z.n && N(ae, "data-tab", Z.n = rt), it !== Z.s && N(ae, "tabindex", Z.s = it), Z;
            }, {
              e: void 0,
              t: void 0,
              a: void 0,
              o: void 0,
              i: void 0,
              n: void 0,
              s: void 0
            }), R(() => ae.value = j.slug), R(() => ae.checked = F(j.slug)), G;
          })()
        }), null), g(ne, _(er, {
          parentRef: S,
          childrenRef: C,
          indicatorClass: `${t}__indicator`,
          get selectedChildSlug() {
            return b()[u].slug;
          }
        }), null), V;
      }
    })), g(q, _(k, {
      get when() {
        return L(() => !!d())() && W();
      },
      get children() {
        var V = or(), Y = V.firstChild, ee = Y.firstChild, ne = Y.nextSibling, j = ne.firstChild, ue = j.firstChild, G = j.nextSibling, oe = G.firstChild, ae = oe.nextSibling;
        return h(V, `${t}__callout`), h(Y, `${t}__callout-eyebrow`), g(ee, () => d().eyebrow), h(ne, `${t}__callout-trigger button has--tooltip`), h(j, `${t}__callout-link`), g(ue, () => d().tooltipText), g(ne, _(fe, {
          get each() {
            return d().labels;
          },
          children: (re, me) => (() => {
            var de = gt(), Z = de.firstChild, Ce = Z.nextSibling;
            return h(de, `${t}__callout-label`), h(Z, `${t}__callout-label-text`), g(Z, () => re.label), h(Ce, `${t}__callout-label-date`), g(Ce, () => re.date), de;
          })()
        }), G), h(G, `${t}__tooltip`), h(oe, `${t}__tooltip-text`), g(oe, () => d().tooltipText), h(ae, `${t}__tooltip-icon`), R((re) => {
          var me = d().buttonLink, de = le() ? "block-end" : "inline-end";
          return me !== re.e && N(j, "href", re.e = me), de !== re.t && N(G, "tip-position", re.t = de), re;
        }, {
          e: void 0,
          t: void 0
        }), V;
      }
    }), null), J((V) => f = V, te), h(te, `${t}__grid`), g(te, _(k, {
      get when() {
        return !E();
      },
      get children() {
        return _(Vn, {
          name: "event-card",
          appear: !0,
          get children() {
            return _(fe, {
              get each() {
                return m();
              },
              children: (V, Y) => _(Ze, ie(V, {
                get key() {
                  return Y();
                },
                get index() {
                  return Y();
                }
              }))
            });
          }
        });
      }
    }), null), g(te, _(k, {
      get when() {
        return E();
      },
      get children() {
        return _(fe, {
          get each() {
            return m();
          },
          children: (V, Y) => _(Ze, ie(V, {
            get key() {
              return Y();
            },
            get index() {
              return Y();
            }
          }))
        });
      }
    }), null), g(P, _(k, {
      get when() {
        return L(() => !!d())() && T();
      },
      get children() {
        return K();
      }
    }), null), P;
  })();
}, zr = ye("inauguration-events", { ...Nt, customElement: !0 }, ur), Vt = {
  activeState: "countdown",
  classBlock: "livestream-block",
  classes: "",
  customElement: !1,
  header: {
    title: "",
    text: ""
  },
  sectionId: "livestream",
  labels: {
    next: "",
    playing: "",
    upcoming: "",
    past: ""
  },
  streams: [],
  themes: {
    block: "light",
    viewer: "dark"
  },
  timer: {
    headline: "",
    mode: "auto",
    set: null
  }
}, Ft = {
  autoplay: !1,
  classBlock: "video-embed",
  closedcaption: !1,
  customElement: !1,
  errorMessage: "Sorry, no video found.",
  id: "video-embed",
  params: {},
  ref: null,
  videoSrc: ""
}, dr = [
  {
    preset: "youtube",
    reg: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
    url: "https://www.youtube.com/embed/$5",
    params: {
      autoplay: !1,
      "picture-in-picture": 1,
      accelerometer: 1,
      gyroscope: 1
    }
  },
  {
    preset: "vimeo",
    reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
    url: "https://player.vimeo.com/video/$1",
    params: {
      autoplay: !1,
      title: 0,
      byline: 0,
      portrait: 0
    }
  },
  {
    preset: "kaltura",
    reg: /^.*kaltura.com\/.*/i,
    skipParse: !0
  }
];
var fr = /* @__PURE__ */ w("<div part=message><div part=message-text>"), hr = /* @__PURE__ */ w('<div part=embed><iframe loading=lazy sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"class=embed-responsive-item allowfullscreen>'), gr = /* @__PURE__ */ w("<div part=root>");
const Je = (e) => {
  e = ie(Ft, e), e.customElement && we();
  let t;
  const [n, r] = M(!1), [i, l] = M(null), o = () => {
    e.videoSrc && dr.forEach((c) => {
      if (!c.reg.exec(e.videoSrc))
        return;
      if (c.skipParse) {
        l(e.videoSrc);
        return;
      }
      const a = Object.assign({}, e.params, c.params);
      a.autoplay = e.autoplay;
      const f = Object.keys(a).map((v) => v + "=" + a[v]).join("&"), d = c.url.indexOf("?") >= 0 ? "&" : "?", $ = e.videoSrc.replace(c.reg, c.url);
      l(`${$}${d}${f}`);
    });
  }, s = () => (() => {
    var c = fr(), u = c.firstChild;
    return g(u, () => e.errorMessage), R((a) => {
      var f = `${e.classBlock}__message`, d = `${e.classBlock}__message-text`;
      return f !== a.e && h(c, a.e = f), d !== a.t && h(u, a.t = d), a;
    }, {
      e: void 0,
      t: void 0
    }), c;
  })();
  return pe(() => {
    i() && r(!0);
  }), he(() => {
    o();
  }), (() => {
    var c = gr(), u = t;
    return typeof u == "function" ? J(u, c) : t = c, g(c, _(k, {
      get when() {
        return n();
      },
      get fallback() {
        return s();
      },
      get children() {
        var a = hr(), f = a.firstChild;
        return R((d) => {
          var $ = `${e.classBlock}__embed embed-responsive`, v = `${e.autoplay ? "autoplay" : ""}`, b = i();
          return $ !== d.e && h(a, d.e = $), v !== d.t && N(f, "allow", d.t = v), b !== d.a && N(f, "src", d.a = b), d;
        }, {
          e: void 0,
          t: void 0,
          a: void 0
        }), a;
      }
    })), R(() => h(c, `${e.classBlock}__root`)), c;
  })();
};
var vr = /* @__PURE__ */ w("<div><svg height=16 width=16><use>"), mr = /* @__PURE__ */ w("<h3>"), _r = /* @__PURE__ */ w("<div><div>"), $r = /* @__PURE__ */ w('<button><span><svg class="icon icon--icon-info"height=16 width=16><use href=#icon-info></use></svg></span><span>View Event'), br = /* @__PURE__ */ w('<div><div><div></div><div></div></div><div></div><sl-dialog class="dialog dialog--event-card theme--light">', !0, !1);
const pr = {
  classBlock: "livestream-block",
  icon: "",
  slug: "",
  streams: [],
  title: ""
}, Ae = (e) => {
  e = ie(pr, e);
  const {
    classBlock: t,
    streams: n,
    icon: r,
    title: i,
    slug: l
  } = e;
  return (() => {
    var o = _r(), s = o.firstChild;
    return J((c) => c, o), h(o, `${t}__stream-pill ${t}__stream-pill--${l}`), h(s, `${t}__stream-pill-header`), g(s, _(k, {
      when: r,
      get children() {
        var c = vr(), u = c.firstChild, a = u.firstChild;
        return h(c, `${t}__stream-pill-icon`), N(u, "class", `icon icon--${r}`), N(a, "href", `#${r}`), c;
      }
    }), null), g(s, _(k, {
      when: i,
      get children() {
        var c = mr();
        return h(c, `${t}__stream-pill-title`), g(c, i), c;
      }
    }), null), g(o, _(fe, {
      each: n,
      children: (c) => _(wr, {
        classBlock: t,
        stream: c
      })
    }), null), o;
  })();
}, wr = (e) => {
  const {
    classBlock: t,
    stream: n
  } = e;
  let r;
  const i = (s) => `${new Date(s).toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric"
  })}`, l = (s) => `${new Date(s).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: !0
  })}`, o = () => {
    r && r.show();
  };
  return (() => {
    var s = br(), c = s.firstChild, u = c.firstChild, a = u.nextSibling, f = c.nextSibling, d = f.nextSibling;
    return h(c, `${t}__stream-pill-stream-timestamp`), h(u, `${t}__stream-pill-stream-time`), g(u, () => l(n.timestamp)), h(a, `${t}__stream-pill-stream-date`), g(a, () => i(n.timestamp)), h(f, `${t}__stream-pill-stream-title`), g(f, () => n.title), g(s, _(k, {
      get when() {
        return n.associatedEvent;
      },
      get children() {
        var $ = $r(), v = $.firstChild;
        v.firstChild;
        var b = v.nextSibling;
        return $.$$click = o, h($, `${t}__stream-pill-trigger`), h(v, `${t}__stream-pill-trigger-icon`), h(b, `${t}__stream-pill-trigger-text`), $;
      }
    }), d), J(($) => r = $, d), d._$owner = nn(), g(d, _(Ze, ie(() => Se(n.associatedEvent), {
      isModal: !0
    }))), R(() => h(s, `${t}__stream-pill-stream ${n.associatedEvent ? `${t}__stream-pill-stream--has-event` : ""}`)), s;
  })();
};
kt(["click"]);
var yr = /* @__PURE__ */ w("<h2>"), Cr = /* @__PURE__ */ w("<div>"), xr = /* @__PURE__ */ w("<header>"), Sr = /* @__PURE__ */ w("<h3>"), Er = /* @__PURE__ */ w('<section part=root><div class="livestream-block__grid container__content--content"><div part=viewer><div><div><svg class="icon icon--university-seal university-seal__svg"height=72 width=72><use href=#university-seal>');
const kr = (e) => {
  e = ie(Vt, e);
  const {
    activeState: t,
    classBlock: n,
    classes: r,
    customElement: i,
    header: l,
    labels: o,
    sectionId: s,
    streams: c,
    themes: u,
    timer: a
  } = e;
  i && we();
  let f;
  const [d, $] = M(0), [v, b] = M([]), [A, z] = M(t), B = () => v().filter((y) => y.state === "upcoming").sort((y, I) => y.timestamp - I.timestamp), m = () => v().filter((y) => y.state === "playing").sort((y, I) => y.timestamp - I.timestamp), p = () => {
    const E = v().filter((y) => y.state === "playing");
    return E.length > 0 ? E[0] : m().pop();
  }, S = () => {
    const E = m().filter((I) => I !== p()), y = v().filter((I) => I.state === "past");
    return [...E, ...y].sort((I, W) => I.timestamp - W.timestamp);
  }, C = () => {
    $(Date.now()), setInterval(() => {
      $(Date.now());
    }, 1e3);
  }, x = () => {
    v().forEach((E) => {
      if (!E?.locked) {
        if (d() < E.timestamp)
          return E.state = "upcoming";
        if (d() >= E.timestamp)
          return E.state = "playing";
      }
    });
  }, F = () => {
    let E = [];
    if (c.length)
      return c.forEach((y) => (y.timestamp = Date.parse(y.timestamp), y.locked = y?.state !== "auto", E = [...E, Se(y)])), b(E);
  }, D = (E) => {
    if (!E)
      return null;
    const I = /<iframe.*?src="(.*?)".*?>/g.exec(E);
    return I && I.length > 1 ? I[1] : E;
  };
  return he(() => {
    C(), Xe(f, e), F(), x();
  }), pe((E) => {
    E !== d() && x();
  }), pe(() => {
    p() && z("video");
  }), (() => {
    var E = Er(), y = E.firstChild, I = y.firstChild, W = I.firstChild, le = W.firstChild;
    return J((T) => f = T, E), N(E, "id", s), g(y, _(k, {
      get when() {
        return l.title || l.text;
      },
      get children() {
        var T = xr();
        return h(T, `${n}__header`), g(T, _(k, {
          get when() {
            return l.title;
          },
          get children() {
            var O = yr();
            return h(O, `${n}__title`), g(O, () => l.title), O;
          }
        }), null), g(T, _(k, {
          get when() {
            return l.text;
          },
          get children() {
            var O = Cr();
            return h(O, `${n}__text rich-text`), R(() => O.innerHTML = l.text), O;
          }
        }), null), T;
      }
    }), I), g(y, _(k, {
      get when() {
        return p();
      },
      get children() {
        return _(Ae, {
          get streams() {
            return [p()];
          },
          icon: "icon-video",
          get title() {
            return o.playing;
          },
          slug: "playing"
        });
      }
    }), I), g(y, _(k, {
      get when() {
        return L(() => B().length > 0)() && !p();
      },
      get children() {
        return _(Ae, {
          get streams() {
            return B();
          },
          icon: "icon-clock",
          get title() {
            return o.upcoming;
          },
          slug: "upcoming"
        });
      }
    }), I), g(y, _(k, {
      get when() {
        return L(() => B().length > 0)() && p();
      },
      get children() {
        return _(Ae, {
          get streams() {
            return B();
          },
          icon: "icon-clock",
          get title() {
            return o.next;
          },
          slug: "next"
        });
      }
    }), I), J((T) => T, W), h(W, `${n}__viewer-inner`), h(le, `${n}__viewer-graphic university-seal`), g(W, _(k, {
      get when() {
        return L(() => !!a?.headline)() && A() === "countdown";
      },
      get children() {
        var T = Sr();
        return h(T, `${n}__timer-headline`), g(T, () => a.headline), T;
      }
    }), null), g(W, _(k, {
      get when() {
        return A() === "countdown";
      },
      get children() {
        return _(Ye, {
          class: `${n}__countdown-timer countdown-timer`,
          get targetTime() {
            return a.set;
          }
        });
      }
    }), null), g(W, _(k, {
      get when() {
        return L(() => A() === "video")() && p();
      },
      get children() {
        return _(Je, {
          get videoSrc() {
            return D(p()?.embedUrl) ?? null;
          },
          class: `${n}__video-embed video-embed`
        });
      }
    }), null), g(y, _(k, {
      get when() {
        return S().length > 0;
      },
      get children() {
        return _(Ae, {
          get streams() {
            return S().reverse();
          },
          icon: "icon-clock",
          get title() {
            return o.past;
          },
          slug: "past"
        });
      }
    }), null), R((T) => {
      var O = `${n} container--fluid ${r} theme--${u.block} ${n}--${A()}-active`, K = `${n}__viewer theme--${u.viewer}`;
      return O !== T.e && h(E, T.e = O), K !== T.t && h(I, T.t = K), T;
    }, {
      e: void 0,
      t: void 0
    }), E;
  })();
}, Dr = ye("live-stream", { ...Vt, customElement: !0 }, kr), Nr = ye("countdown-timer", { ...Lt, customElement: !0 }, Ye), Vr = ye("video-embed", { ...Ft, customElement: !0 }, Je), Kt = {
  classBlock: "video-mask",
  closedcaption: !1,
  customElement: !1,
  errorMessage: "Sorry, no video found.",
  id: "video-mask",
  mode: "ui-only",
  // ui-only, placeholder-image, embed.
  params: {},
  placeholderImage: {
    src: "",
    alt: ""
  },
  playButton: null,
  // accepts SVG use link.
  ref: null,
  transitionName: "fade",
  videoSrc: ""
};
var Tr = /* @__PURE__ */ w('<svg viewBox="0 0 82 82"fill=none><path d="M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z"stroke="var(--icon-color, currentColor)"stroke-width=2 stroke-linecap=round stroke-linejoin=round></path><path d="M33 25L57 41L33 57V25Z"stroke="var(--icon-color, currentColor)"stroke-width=2 stroke-linecap=round stroke-linejoin=round>'), Ar = /* @__PURE__ */ w("<img part=placeholder>"), Pr = /* @__PURE__ */ w('<svg viewBox="0 0 24 24"fill=none><use>'), Lr = /* @__PURE__ */ w("<div part=mask><button part=trigger><div class=sr-only>Play Video"), Br = /* @__PURE__ */ w("<div part=root>"), Rr = /* @__PURE__ */ w("<div part=video>");
const Or = (e) => {
  e = ie(Kt, e), e.customElement && we();
  let t;
  const [n, r] = M(!1), i = () => {
    r(!0);
  }, l = (u, a) => {
    u.animate({
      opacity: [0, 1]
    }, {
      duration: 600
    }).finished.then(a);
  }, o = (u, a) => {
    u.animate([{
      opacity: 1
    }, {
      opacity: 0
    }], {
      duration: 600
    }).finished.then(a);
  }, s = () => (() => {
    var u = Tr();
    return R(() => N(u, "class", `${e.classBlock}__play-btn icon icon--icon-play`)), u;
  })(), c = () => (() => {
    var u = Lr(), a = u.firstChild;
    return a.firstChild, g(u, _(k, {
      get when() {
        return e.placeholderImage?.src;
      },
      get children() {
        var f = Ar();
        return R((d) => {
          var $ = e.placeholderImage.src, v = e.placeholderImage.alt, b = `${e.classBlock}__placeholder`;
          return $ !== d.e && N(f, "src", d.e = $), v !== d.t && N(f, "alt", d.t = v), b !== d.a && h(f, d.a = b), d;
        }, {
          e: void 0,
          t: void 0,
          a: void 0
        }), f;
      }
    }), a), a.$$click = i, g(a, _(k, {
      get when() {
        return e.playButton;
      },
      get fallback() {
        return s();
      },
      get children() {
        var f = Pr(), d = f.firstChild;
        return R(($) => {
          var v = `${e.classBlock}__play-btn icon icon--icon-play`, b = e.playButton;
          return v !== $.e && N(f, "class", $.e = v), b !== $.t && N(d, "href", $.t = b), $;
        }, {
          e: void 0,
          t: void 0
        }), f;
      }
    }), null), R((f) => {
      var d = `${e.classBlock}__mask`, $ = `${e.classBlock}__trigger`;
      return d !== f.e && h(u, f.e = d), $ !== f.t && h(a, f.t = $), f;
    }, {
      e: void 0,
      t: void 0
    }), u;
  })();
  return (() => {
    var u = Br(), a = t;
    return typeof a == "function" ? J(a, u) : t = u, g(u, _(Nn, {
      mode: "outin",
      onEnter: l,
      onExit: o,
      get children() {
        return L(() => !!n())() ? (() => {
          var f = Rr();
          return g(f, _(Je, {
            get videoSrc() {
              return e.videoSrc;
            },
            autoplay: !0,
            get params() {
              return e.params;
            },
            get closedcaption() {
              return e.closedcaption;
            },
            get errorMessage() {
              return e.errorMessage;
            }
          })), R(() => h(f, `${e.classBlock}__video`)), f;
        })() : c();
      }
    })), R(() => h(u, `${e.classBlock}__root`)), u;
  })();
};
kt(["click"]);
const Fr = ye("video-mask", { ...Kt, customElement: !0 }, Or);
export {
  jr as Countdown,
  zr as InaugurationEvents,
  Dr as Livestream,
  Nr as Timer,
  Vr as VideoEmbed,
  Fr as VideoMask
};
